// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fv-0";
export var actionModalContentContainer = "_fv-1";
export var createTagButton = "_fv-2";
export var footerContainer = "_fv-7";
export var fullWidthDivider = "_fv-3";
export var hasCreateTagButton = "_fv-4";
export var noCreateTagButton = "_fv-5";
export var tagsContainer = "_fv-6";
export var tagsModalContentContainer = "_fv-8";